// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_31ZyZAmeI1sPQsH4nX3URl","sk-stretchdelay":"mGOM_13K8RMtkNmRxn6zJ","rect2":"_3fZQMwiyc9wZZ3a2F_njBY","rect3":"_24CACLGBvH3LwD7fG4q69E","rect4":"_2yo0k8ACSkN86NeTVhfgRy","rect5":"FAe6p61sO3kDLZZwn-PJg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Spinner/style.scss
// module id = 937
// module chunks = 0